var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"statistics-body"},[_c('b-img-lazy',{attrs:{"src":require('@/assets/images/portrait/kultiver.jpg'),"fluid":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }